import { type PropsWithChildren, useMemo } from "react";

import { EditWorkoutItemWorkoutSetProvider } from "src/components/EditWorkoutItemWorkoutSetProvider";
import { NoopCell } from "src/components/NoopWorkoutSetCell";
import {
  type WorkoutItemSetsContextValue,
  workoutSetsWorkoutItemSetsContext,
} from "src/workouts/WorkoutItemSetContext.shared";
import {
  type WorkoutPermissionContextValue,
  workoutPermissionsContext,
} from "src/workouts/WorkoutItemsPermission";

export function EditWorkoutSetsWorkoutItemSetsProvider(
  props: PropsWithChildren & { canAddComments?: boolean },
) {
  const value = useMemo<WorkoutItemSetsContextValue>(() => {
    return {
      Provider: EditWorkoutItemWorkoutSetProvider,
      getLogCells: () => {
        return [NoopCell, NoopCell];
      },
    };
  }, []);

  const permissionsValue = useMemo<WorkoutPermissionContextValue>(() => {
    return {
      dragAndDropEnabled: true,
      canEditItems: true,
      canEditSets: true,
      canLogSets: false,
      canEditWorkout: true,
      workoutItemSetShown: true,
      canAddComments: props.canAddComments ?? true,
      canAddRootItems: true,
      canImportFromLibrary: true,
      canEditAttributes: true,
    };
  }, []);

  return (
    <workoutPermissionsContext.Provider value={permissionsValue}>
      <workoutSetsWorkoutItemSetsContext.Provider value={value}>
        {props.children}
      </workoutSetsWorkoutItemSetsContext.Provider>
    </workoutPermissionsContext.Provider>
  );
}
